// return the user data from the session storage
import {Redirect} from "react-router-dom";
import React from "react";

export const getUser = () => {
    const userStr = sessionStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    else return null;
}

// return the token from the session storage
export const getToken = () => {
    return sessionStorage.getItem('token') || null;
}

// remove the token and user from the session storage
export const removeUserSession = () => {
    console.log("Removing session!")
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
}


// set the token and user from the session storage
export const setUserSession = (token, user) => {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(user));
}

export const catchErrors = (errorInfo) => {
    // Default message
    let error_detail_txt = 'Sin descripción en mensaje de error.';

    // Normalize status and payload across different libs (axios, reqwest, fetch/jQuery-like)
    const status = (errorInfo && (errorInfo.status || (errorInfo.response && errorInfo.response.status))) || 0;
    let payload = null;

    // axios-style: error.response.data
    if (errorInfo && errorInfo.response && typeof errorInfo.response.data !== 'undefined') {
        payload = errorInfo.response.data;
    } else if (errorInfo && typeof errorInfo.responseText === 'string') {
        // reqwest/jQuery-style: responseText
        try {
            payload = JSON.parse(errorInfo.responseText);
        } catch (e) {
            // If it's plain text, use it as-is
            if (errorInfo.responseText.trim()) {
                return errorInfo.responseText;
            }
        }
    } else if (typeof errorInfo === 'string') {
        // Direct string
        return errorInfo;
    }

    // Try to extract a meaningful message from known keys first
    const pickFirstText = (val) => {
        if (val == null) return null;
        if (typeof val === 'string') return val;
        if (Array.isArray(val)) {
            // Return first non-empty string
            const first = val.find((x) => typeof x === 'string' && x.trim());
            return first || (val.length ? String(val[0]) : null);
        }
        return null;
    };

    if (payload && typeof payload === 'object') {
        // Common patterns from backend
        const directKeys = ['error', 'detail', 'message', 'non_field_errors'];
        for (const k of directKeys) {
            if (k in payload) {
                const txt = pickFirstText(payload[k]);
                if (txt) return txt;
            }
        }
        // If payload is a dict of field -> [errors], aggregate nicely
        try {
            const parts = [];
            Object.entries(payload).forEach(([k, v]) => {
                if (k === 'errors' && typeof v === 'string') {
                    parts.push(v);
                } else {
                    const arr = Array.isArray(v) ? v : [v];
                    const msgs = arr
                        .map((x) => (typeof x === 'string' ? x : (x && x.message) || JSON.stringify(x)))
                        .filter(Boolean);
                    if (msgs.length) {
                        parts.push(`${k}: ${msgs.join(' | ')}`);
                    }
                }
            });
            if (parts.length) return parts.join('\n');
        } catch (e) {
            // ignore and fallthrough
        }
    } else if (typeof payload === 'string' && payload.trim()) {
        return payload;
    }

    // If no backend message was extracted, fall back to common status messages
    if (status === 404) {
        return 'El registro deseado no fue encontrado.';
    }
    if (status === 403) {
        return 'No tiene permisos para realizar esta acción.';
    }

    return error_detail_txt;
}

// Format numeric dose as a fractional string (nearest quarter), without changing DB types
export const formatDoseFraction = (val) => {
  if (val == null || val === '') return '';
  const n = typeof val === 'number' ? val : parseFloat(String(val).replace(',', '.'));
  if (isNaN(n)) return String(val);
  // Round to nearest quarter to match UI presets (1/4 steps)
  const rounded = Math.round(n * 4) / 4;
  const isNeg = rounded < 0;
  const abs = Math.abs(rounded);
  const whole = Math.floor(abs + 1e-8);
  const frac = abs - whole;
  let fracStr = '';
  const eps = 1e-8;
  if (Math.abs(frac - 0.25) < eps) fracStr = '1/4';
  else if (Math.abs(frac - 0.5) < eps) fracStr = '1/2';
  else if (Math.abs(frac - 0.75) < eps) fracStr = '3/4';
  else if (frac < eps) fracStr = '';
  else {
    // Fallback: show up to 2 decimals if it's not a quarter step
    const txt = abs.toFixed(2).replace(/\.00$/, '');
    return (isNeg ? '-' : '') + txt;
  }
  let res = '';
  if (whole > 0 && fracStr) res = `${whole} ${fracStr}`;
  else if (whole > 0) res = `${whole}`;
  else if (fracStr) res = fracStr;
  else res = '0';
  return isNeg ? `-${res}` : res;
};

// Format numeric dose as decimal string (up to 2 decimals), trimming trailing zeros
export const formatDoseDecimal = (val) => {
  if (val == null || val === '') return '';
  const n = typeof val === 'number' ? val : parseFloat(String(val).replace(',', '.'));
  if (isNaN(n)) return String(val);
  const txt = n.toFixed(2).replace(/\.00$/, '').replace(/(\.[1-9])0$/, '$1');
  return txt;
};

// Decide how to format the dose based on unit: if unit is 'partes' (default) or empty -> fraction; otherwise decimal
export const formatDoseByUnit = (val, unit) => {
  const u = (unit || '').toString().trim().toLowerCase();
  if (!u || u === 'partes' || u === 'parte') {
    return formatDoseFraction(val);
  }
  return formatDoseDecimal(val);
};
